import moment from 'moment';
import React from 'react';
import { withTooltip, TOOLTIP_HORIZONTAL_ALIGNMENTS, THEMES, TOOLTIP_VERTICAL_ALIGNMENTS } from 'cdk-radial';

export const dateComparator = (date1, date2) => {

    let d1= moment(date1, 'MM/DD/YYYY HH:mm:ss');
    let d2 = moment(date2, 'MM/DD/YYYY HH:mm:ss')
  
    return (d1 === d2) ? 0 : (d1 > d2) ? 1 : -1;
  };
  
export const getLatestDate = (subscription)=>{
    let dateArray = [];
    subscription && subscription.map(item => {
      if(item.lastUpdatedOn || item.lastUpdated){
        const date = new Date(item.lastUpdatedOn || item.lastUpdated)
        dateArray.push((date));
      }
    })
    let latestDate = dateArray.length && dateArray.reduce((a, b) => (a > b ? a : b));
    return latestDate ? moment(latestDate).format('MM/DD/YYYY HH:mm:ss') : 'NA';
};

export const showTooltip = (text) => {
  const tooltipProps = {
      id: 'table-tooltip',
      text: text,
      theme: THEMES.LIGHT
  };

  const ComponentToRender = props => {
      return <div {...props}>{text}</div>;
  };

  const ComponentWithTooltip = withTooltip(ComponentToRender, tooltipProps);
  return <div css="display: flex;" className='tooltip'>
      <ComponentWithTooltip horizontalAlignment={TOOLTIP_HORIZONTAL_ALIGNMENTS.MIDDLE} marginAroundElement={8} verticalAlignment={TOOLTIP_VERTICAL_ALIGNMENTS.BOTTOM} />
      </div>;

}

export const onGridReady = params => {
  const sortModel = [
      {colId: 'subscribedOn', sort: 'desc'}
  ];
  params.api.setSortModel(sortModel);
}
